// @flow

import { action, observable } from "mobx";

import Store from "app/stores/Store";
import VideoStore from "app/stores/VideoStore";

import GlobalSettingsStore from "./GlobalSettingsStore";

class VideoEditorStore extends Store {
    @observable hoverProgress: ?number;

    @action.bound
    setHoverProgress(hoverProgress: ?number) {
        if (
            VideoStore.isEditable &&
            GlobalSettingsStore.newItemFollowEffect === "default"
        ) {
            this.hoverProgress = hoverProgress;
        }
    }
}

export default new VideoEditorStore();



// WEBPACK FOOTER //
// ./src/app/stores/VideoEditorStore.js